import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Divider,
  Radio,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getSearchApi } from '../../../network/itemList';
import TaxtList from './TaxtList';
import PurchaseReceipts from './PurchaseReceipts';
import {
  addLandedCostVoucher,
  getLandedCostVoucherDetails,
  updateLandedCostVoucher,
} from '../../../network/landedCostVoucher';
import ItemList from './ItemOrderList';
import { submitMaterialRequest } from '../../../network/materialRequest';
import HeadingApp from '../../../hooks/HeadingApp';
import { FaReceipt } from 'react-icons/fa';
const AddLandedCostVoucher = ({ t, edit, order }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [submitButton, setSubmitButton] = useState(false);
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [dataSource, setDataSource] = useState([{}]);
  const [dataSourcePurchase, setDataSourcePurchase] = useState([
    {
      key: 0,
      description: 'New itemName',
      items: [
        {
          key: 0,
        },
      ],
    },
  ]);
  const [dataSourceItemList, setDataSourceItemList] = useState([{}]);
  const watchDistributeCharges = Form.useWatch(
    'distribute_charges_based_on',
    form
  );
  const { id, idOrder } = useParams();
  const { companyName, currentLang } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddLandedCostVoucher } = useMutation({
    mutationKey: ['addLandedCostVoucher'],
    mutationFn: (body) =>
      edit ? updateLandedCostVoucher(body, id) : addLandedCostVoucher(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      client.invalidateQueries({ queryKey: [queryKeys.getLandedCostVoucher] });
      form.resetFields();
      if (edit && dataStatus !== 0) {
        navigate('/landed-cost-voucher');
      }
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Landed Cost Voucher', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }

      message.success(data?.message?.message || 'Submitted successfully');
      submitButton && navigate('/landed-cost-voucher');
      client.invalidateQueries({
        queryKey: [queryKeys.getLandedCostVoucher, id],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data: taxesCharges } = useQuery({
    queryKey: [queryKeys.getItemTaxTemplate],
    queryFn: () => getSearchApi('Purchase Taxes and Charges Template'),
    keepPreviousData: true,
  });
  const { data: landedCostVoucher, isLoading } = useQuery({
    queryKey: [queryKeys.getLandedCostVoucher, id],
    queryFn: () => getLandedCostVoucherDetails(id),
    enabled: !!id,
  });
  useEffect(() => {
    if (edit && landedCostVoucher) {
      setDataSource(
        landedCostVoucher?.data?.taxes?.length
          ? landedCostVoucher?.data?.taxes
          : [{}]
      );
      setDataSourcePurchase(
        landedCostVoucher?.data?.purchase_receipts?.length
          ? landedCostVoucher?.data?.purchase_receipts?.map((item) => ({
              ...item,
              items: landedCostVoucher?.data?.items?.length
                ? landedCostVoucher?.data?.items
                : [{}],
            }))
          : [
              {
                key: 0,
                items: [
                  {
                    key: 0,
                  },
                ],
              },
            ]
      );
      setDataSourceItemList(
        landedCostVoucher?.data?.items?.length
          ? landedCostVoucher?.data?.items
          : [{}]
      );
      setDataStatus(landedCostVoucher?.data?.docstatus);
      form.setFieldsValue({
        ...landedCostVoucher?.data,
        posting_date: dayjs(landedCostVoucher?.data?.posting_date),
      });
    } else {
      form.resetFields();
    }
  }, [edit, landedCostVoucher, form]);
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddLandedCostVoucher({
      ...values,
      company: companyName,
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      taxes: dataSource?.[0]?.expense_account
        ? dataSource?.map((item) => ({ ...item }))
        : [],
      purchase_receipts: dataSourcePurchase?.map((item, index) => ({
        receipt_document_type: item?.receipt_document_type,
        receipt_document: item?.receipt_document,
        supplier: item?.supplier,
        posting_date: item?.posting_date,
        grand_total: item?.grand_total,
        description: item?.description,
        key: index,
      })),
      // items: dataSourceItemList?.map((item) => ({ ...item })),
      // items: dataSourcePurchase?.flatMap((item, index) =>
      //   item?.items?.map((item) => ({ ...item, id: index,

      //    }))
      // ),
      items: dataSourcePurchase?.flatMap((data, index) =>
        data?.items?.map((item) => ({
          ...item,
          id: index,
          ...(item.receipt_document_type === 'Purchase Receipt'
            ? { purchase_receipt_item: item?.name }
            : item.receipt_document_type === 'Purchase Invoice'
            ? { purchase_invoice_item: item?.name }
            : {}),
        }))
      ),
    });
  };
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.Inventory}
        subTitle={edit ? t.editLandedCostVoucher : t.AddLandedCostVoucher}
        path="/landed-cost-voucher"
      /> */}
      <HeadingApp
        nameTab={t.Inventory}
        title={t.LandedCostVoucher}
        subTitle={edit ? t.editLandedCostVoucher : t.AddLandedCostVoucher}
        icon={<FaReceipt />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-landed-cost-voucher-form"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="distribute_charges_based_on"
                    label={t.distributeChargesBasedOn}
                    rules={[{ required: true }]}
                    initialValue="Qty"
                  >
                    <Select
                      placeholder={t.distributeChargesBasedOn}
                      options={[
                        {
                          value: 'Qty',
                          label: t.quantity,
                        },
                        {
                          value: 'Amount',
                          label: t.amount,
                        },
                        {
                          value: 'Distribute Manually',
                          label: t.DistributeManually,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.postingDate}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="company"
                    label={t.company}
                    initialValue={companyName}
                  >
                    <Input placeholder={t.company} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_taxes_and_charges"
                    label={t.TotalTaxesandCharges}
                    hidden={!edit}
                  >
                    <Input placeholder={t.TotalTaxesandCharges} disabled />
                  </Form.Item>
                </Col>

                <Divider orientation="left">{t.PurchaseReceipts}</Divider>
                <Col span={24}>
                  <PurchaseReceipts
                    dataSourcePurchase={dataSourcePurchase}
                    watchDistributeCharges={watchDistributeCharges}
                    setDataSourcePurchase={setDataSourcePurchase}
                    setDataSourceItemList={setDataSourceItemList}
                    t={t}
                    form={form}
                    setSelectedIndex={setSelectedIndex}
                    selectedIndex={selectedIndex}
                  />
                </Col>
                <Divider orientation="left">{t.items}</Divider>
                <Col span={24}>
                  <ItemList
                    dataSourceItemList={dataSourceItemList}
                    setDataSourceItemList={setDataSourceItemList}
                    t={t}
                    watchDistributeCharges={watchDistributeCharges}
                    setDataSourcePurchase={setDataSourcePurchase}
                    dataSourcePurchase={dataSourcePurchase}
                    setSelectedIndex={setSelectedIndex}
                    selectedIndex={selectedIndex}
                  />
                </Col>
                <Divider orientation="left">{t.TaxesandCharges}</Divider>
                <Col span={24}>
                  <TaxtList
                    t={t}
                    form={form}
                    dataSource={dataSource}
                    setDataSource={setDataSource}
                  />
                </Col>
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.Cancel}
                </Button>
                <Button
                  type="primary"
                  // htmlType="submit"
                  loading={loadingAdd}
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      handleSubmit.mutate(selectName);
                    } else {
                      form.submit();
                    }
                  }}
                >
                  {submitButton ? t.submit : edit ? t.edit : t.Save}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddLandedCostVoucher;
